/**
 * External dependencies
 */
import memize from 'memize';

function getHeight() {
	const heightElement = document.createElement( 'div' );
	heightElement.style.height = '100vh';
	document.body.appendChild( heightElement );
	const height = heightElement.offsetHeight;
	document.body.removeChild( heightElement );

	return height;
}

const memoizedGetHeight = memize( getHeight );

export function getWindowHeight() {
	if ( window.innerWidth > 500 ) {
		return 667;
	}

	return memoizedGetHeight( window.innerHeight );
}

export function getWindowWidth() {
	if ( window.innerWidth > 500 ) {
		return 375;
	}

	return window.innerWidth;
}



// WEBPACK FOOTER //
// ./src/utils/window.js